class FBSConfig {
    public FeedbackSubmissionUrl: string
    public LiveChatPopupDelay: number
    public LiveChatEnabledText: string
}
export { FBSConfig }